import { Outlet, useNavigate } from "react-router";

import { Card, TabMenu } from "@digital-services/ui";
import { ITabMenuTab } from "@digital-services/ui/types";

import { useTabIndex } from "@hooks/useTabIndex";

export const TabsSecondLevel = () => {
  const tabs: ITabMenuTab[] = [
    {
      id: "api-secrets",
      label: "API Secrets",
      content: (
        <Card className="mt-0 min-w-[830px]" data-testid="api-secrets-tab-card">
          <Outlet />
        </Card>
      )
    },
    {
      id: "application-roles",
      label: "Application roles",
      content: (
        <Card
          className="mt-0 min-w-[830px]"
          data-testid="application-roles-tab-card"
        >
          <Outlet />
        </Card>
      )
    }
  ];

  const { currentTabIndex } = useTabIndex(tabs);
  const navigate = useNavigate();

  const handleChangeTab = (tabIndex: number) => {
    if (tabIndex === 0) {
      return navigate("");
    }

    navigate(tabs[tabIndex].id.toLowerCase());
  };

  return (
    <TabMenu
      value={currentTabIndex}
      onChange={handleChangeTab}
      tabs={tabs}
      isSubMenu
    />
  );
};
